var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Form, HorizontalRule } from "@brushfire/ui";
import { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import Constants from "../../../../../data/constants";
import FormikContextListener from "../../../../Helpers/FormikContextListener";
import useGroupData from "../../../../../hooks/useGroupData";
var GroupedMatrix = function (_a) {
    var currency = _a.currency, attendeeTypeData = _a.attendeeTypeData, submitAttendees = _a.submitAttendees, eventNumber = _a.eventNumber, typeCode = _a.typeCode, path = _a.path;
    var _b = __read(useState(), 2), selectedTier = _b[0], setSelectedTier = _b[1];
    var _c = __read(useState([]), 2), descriptionsShown = _c[0], setDescriptionsShown = _c[1];
    var intl = useIntl();
    var groupId = useGroupData(eventNumber).groupId;
    useEffect(function () {
        if (![Constants.Routes.tickets, Constants.Routes.register].includes(path)) {
            setSelectedTier(undefined);
        }
    }, [path]);
    var groupedData = useMemo(function () {
        var data = {
            ageGroups: [],
            tiers: [],
            basePrice: 999999999,
            initialValues: {},
        };
        var prices = {};
        //Get max price for each tier
        attendeeTypeData.forEach(function (type) {
            var _a, _b;
            var _c = __read(type.name.split(" - "), 2), group = _c[0], tier = _c[1];
            if (!prices[tier] || prices[tier] < ((_a = type.amount) !== null && _a !== void 0 ? _a : 0)) {
                prices[tier] = (_b = type.amount) !== null && _b !== void 0 ? _b : 0;
            }
        });
        //Get base price from all tiers
        Object.keys(prices).forEach(function (tier) {
            if (prices[tier] < data.basePrice) {
                data.basePrice = prices[tier];
            }
        });
        attendeeTypeData.forEach(function (type) {
            var _a, _b, _c, _d, _e;
            var _f = __read(type.name.split(" - "), 2), group = _f[0], tier = _f[1];
            //Age Groups
            if (data.ageGroups.find(function (a) { return a.label === group; })) {
                var existingGroup = data.ageGroups.find(function (a) { return a.label === group; });
                //Compare
                if (existingGroup && existingGroup.min < type.minQuantity) {
                    existingGroup.min = type.minQuantity;
                }
                if (existingGroup &&
                    ((!existingGroup.max && type.maxQuantity) || ((_a = existingGroup.max) !== null && _a !== void 0 ? _a : 999) > ((_b = type.maxQuantity) !== null && _b !== void 0 ? _b : 999))) {
                    existingGroup.max = type.maxQuantity;
                }
            }
            else {
                data.ageGroups.push({
                    label: group,
                    min: type.minQuantity,
                    max: type.maxQuantity,
                });
            }
            //Ticket Tiers
            if (!data.tiers.find(function (a) { return a.label === tier; })) {
                data.tiers.push({
                    label: tier,
                    price: prices[tier],
                    priceText: "+".concat(intl.formatNumber(prices[tier] - data.basePrice, {
                        style: "currency",
                        currency: currency !== null && currency !== void 0 ? currency : "USD",
                    }), "/ea"),
                    totalText: intl.formatNumber(((_c = type.amount) !== null && _c !== void 0 ? _c : 0) + ((_d = type.tax) !== null && _d !== void 0 ? _d : 0) + ((_e = type.fee) !== null && _e !== void 0 ? _e : 0), {
                        style: "currency",
                        currency: currency !== null && currency !== void 0 ? currency : "USD",
                    }) + " with taxes and fees",
                    description: type.description,
                });
            }
        });
        data.ageGroups.forEach(function (group) {
            data.initialValues[group.label] = "0";
        });
        return data;
    }, [attendeeTypeData]);
    var onSubmit = function (values, formikHelpers, setGlobalError) {
        if (selectedTier) {
            var attendees = attendeeTypeData.map(function (type) {
                var _a;
                var _b = __read(type.name.split(" - "), 2), group = _b[0], tier = _b[1];
                var quantity = tier === selectedTier ? parseInt((_a = values[group]) !== null && _a !== void 0 ? _a : "0") : 0;
                return {
                    typeId: type.id,
                    quantity: quantity,
                    groupId: groupId || null,
                    amount: 0,
                    isPreRegistered: false,
                    seatId: null,
                    sectionId: null,
                    variations: {},
                    externalId: "",
                    externalDescription: "",
                };
            });
            submitAttendees({
                eventNumber: eventNumber,
                attendees: attendees,
                sourceAttendeeId: null,
                typeCode: typeCode !== null && typeCode !== void 0 ? typeCode : "",
            }, formikHelpers, setGlobalError);
        }
    };
    if (![Constants.Routes.tickets, Constants.Routes.register].includes(path)) {
        return null;
    }
    return (_jsx("div", __assign({ className: "grouped-matrix m-bottom" }, { children: _jsx(Form, __assign({ initialValues: groupedData.initialValues, 
            //validationSchema={attendeeTypesSchema}
            formikBagProps: {
                hideButton: true,
            }, onSubmit: onSubmit, useUnsavedPrompt: false }, { children: function (_a) {
                var formikContext = _a.formikContext;
                return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: Constants.Routes.tickets, path: [Constants.Routes.tickets, Constants.Routes.register], formikContext: formikContext, active: true, initialValues: groupedData.initialValues }), _jsx(HorizontalRule, __assign({ className: "tt-uppercase" }, { children: "Number of Guests" })), _jsx("div", __assign({ className: "grouped-matrix-groups" }, { children: groupedData.ageGroups.map(function (group) { return (_jsxs("div", __assign({ className: "grouped-matrix-group" }, { children: [_jsx("h3", { children: group.label }), _jsx(Form.Field, { component: Form.Input.Counter, label: group.label, id: group.label, name: group.label, hiddenLabel: true, type: "counter", min: group.min, max: group.max, disabled: !!selectedTier, allowZeroValue: true, ariaName: group.label })] }), group.label)); }) })), _jsxs("div", __assign({ className: "m-top-medium" }, { children: ["To ensure everyone will be sitting together, please reserve ALL tickets for your group at the same time and in one transaction online. If you are unable to accommodate your entire party, please call us directly at ", _jsx("a", __assign({ href: "tel:+16084327469" }, { children: "(608) 432-7469." }))] })), _jsx(HorizontalRule, __assign({ className: "tt-uppercase" }, { children: "Choose Your Experience" })), _jsx("div", { children: "Please choose your experience based on the options below." }), _jsx("div", __assign({ className: "grouped-matrix-tiers" }, { children: groupedData.tiers.map(function (tier) { return (_jsxs("div", __assign({ className: "grouped-matrix-tier" }, { children: [_jsx("h3", { children: tier.label }), _jsx("strong", __assign({ className: "m-top" }, { children: tier.priceText })), _jsx("small", { children: tier.totalText }), _jsx("p", { className: "flex-1 m-top-medium ".concat(descriptionsShown.includes(tier.label) ? "" : "hide-on-mobile"), dangerouslySetInnerHTML: { __html: tier.description } }), !!tier.description && (_jsx("a", __assign({ href: "", className: "flex-1 m-top-medium ".concat(descriptionsShown.includes(tier.label) ? "hide" : "show-on-mobile"), onClick: function (e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setDescriptionsShown(descriptionsShown.concat([tier.label]));
                                        } }, { children: "View Details" }))), _jsx(Button, __assign({ purpose: "primary", busy: tier.label === selectedTier, disabled: !!selectedTier ||
                                            Object.values(formikContext.values).every(function (v) { return v === "0"; }), classes: "btn-block m-top", onClick: function (e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectedTier(tier.label);
                                            formikContext.submitForm();
                                        } }, { children: "Select" }))] }), tier.label)); }) }))] }));
            } })) })));
};
export default GroupedMatrix;
